import Link from 'next/link';
import React, { useEffect, useState } from 'react';
// import "./style.scss";

// starting redux stuff ...
import store from '../../store';
import { createWrapper } from 'next-redux-wrapper';

// ending redux stuff ...
import dynamic from 'next/dynamic';
const HeadContent = dynamic(() => import('../../hoc/headContent'), { loading: () => <></>, ssr: true });

function getStartedLayout(props) {
	const { userAuth } = store.getState();

	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		// if (userAuth.authenticated && userAuth.token && userAuth.isSignupCompleted) {
		// 	window.location.href = '/home';
		// }
		if (window.innerWidth < 767) {
			setIsMobile(true);
		}
	}, []);

	return (
		<>
			<HeadContent
				title={props.meta.title}
				description={props.meta.description}
				route={props.meta.route}
			/>
				<div className="get-started-layout">
					<div className="register-header">
					{/* <Link href="/" as="/">
						<a>
							<img src="/icons/bayan-only.svg" alt="bayan-logo" width="200" height="75" />
						</a> */}
						{/* <a><img src="/icons/logo-in.png"></img> BAYAN</a> */}
					{/* </Link> */}
					<Link href="/" as="/">
						{
							isMobile ? 
									<span className="logo-area"><a><img src="/icons/logo-in.png"></img> BAYAN</a></span>
									:
									<a>
										<img src="/icons/bayan-only.svg" alt="bayan-logo" width="200" height="70" />
									</a>
						}
					</Link>
						{/* <a className="page-close"></a> */}
					</div>
					<div className="get-started-content">
						{props.children}
					</div>
				</div>
		</>
	);
}

const makeStore = () => store;
const wrapper = createWrapper(makeStore);

export default wrapper.withRedux(getStartedLayout);
